<template>
  <button id="NUMBER_0" name="0" class="btn num-btn" data-vcode="NUMBER_0" :aria-label="`0 ${$t('spaceButton')}`">
    <div class="digit">0</div>
    <div class="letters">{{ $t('spaceButton') }}</div>
  </button>
</template>
<script>
export default {};
</script>
